import axios from 'axios';
import { ApiError } from '../error/error';
import { apiClientNoToken } from './apiClient';
// Interface for API response
interface PasswordResetResponse {
  message: string;
  status: string;
}

export const EmailResetLink = async (email: string): Promise<any | null> => {
  try {
       const origin = window.location.origin; // Use the current domain as the origin

    const response = await apiClientNoToken.post('api/password/email', {
      "email" : email,
    });

    console.log('EmailResetLink: ', response);

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to send email for reset password', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};
export const ResetPassword = async (): Promise<PasswordResetResponse | null> => {
  try {
    const response = await apiClientNoToken.get('api/password/reset');
    return response.data as PasswordResetResponse;

  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to reset password', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};

 